import axios from 'utility/axios'
import {
	GET_SETUP_INTENT_CLIENT_SECRET
} from 'utility/endpoints'

export const fetchSetupIntentClientSecret = async () => {
	const res = await axios.get(GET_SETUP_INTENT_CLIENT_SECRET)
	return res.data
}